import { ModalElementContext } from 'contexts/ModalProvider'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import type { FormEventHandler } from 'react'
import React, { useCallback, useContext, useRef } from 'react'
import OfferCapacityWithAgesSelection from '../Filters/CapacityWithAges/OfferCapacityWithAgesSelection'

interface Props {
  capacities: Array<App.RoomCapacity>
}

function BedbankSidebarFilterCapacity({ capacities }: Props) {
  const modalElement = useContext(ModalElementContext)

  const formRef = useRef<HTMLFormElement>(null)

  const onCapacityApply = useCallback<FormEventHandler<HTMLFormElement>>((event) => {
    event.preventDefault()
    if (formRef.current?.reportValidity()) {
      modalElement.resolve()
    }
  }, [modalElement])

  return (
    <form onSubmit={onCapacityApply} ref={formRef}>
      <ModalHeader title="Who is going?" />
      <ModalBody>
        <OfferCapacityWithAgesSelection capacities={capacities} />
      </ModalBody>
      <ModalFooter
        primaryActionProps={{
          children: 'Confirm',
          type: 'submit',
        }}
      />
    </form>
  )
}

export default BedbankSidebarFilterCapacity
